module.exports = __webpack_public_path__ + "img/E-WEB-Goal-13.8b5de418.png";